import { InboundReferralSection } from 'components/notificationPreferences/inboundReferralSections';

// The General page sections: stored categories on the General row, rendered by the same section
// card the Inbound Referrals sections use. Keys are the camelized wire names.
export const GENERAL_SECTIONS: InboundReferralSection[] = [
  {
    category: 'mention',
    title: 'Mentions',
    description: 'When someone tags you in a note on a patient',
    kinds: [{ kind: 'newMention', label: 'Tagged in a Note' }],
  },
];
